export function copy(target) {
  return JSON.parse(JSON.stringify(target));
}